import React, { useRef, useState } from 'react';
import style from "../../css/auth/Register_paynow.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { API_BASE_URL } from '../ApiConfig';
import axios from 'axios';
import { showCustomAlert, showCustomAlerterror } from '../customalert';

import { Link, useNavigate } from 'react-router-dom';
import { getSecureToken } from '../ApisService/apiService';

const Register_paynow = () => {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        mobileNumber: '',
        verificationCode: '',
        password: '',
        rePassword: '',
        acceptPrivacyPolicy: false,
        botTrap: '',
    });
    const [formErrors, setFormErrors] = useState({});
    const [verificationMessage, setVerificationMessage] = useState('');


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const [couponCode, setCouponCode] = useState('');
    const [discount, setDiscount] = useState(0);
    const handleApplyCoupon = () => {
        if (couponCode.trim().toLowerCase() === "swingalgo2000") {
            setDiscount(2000);
            showCustomAlert("Coupon applied successfully! ₹2000 off.");
        } else {
            setDiscount(0);
            showCustomAlerterror("Invalid coupon code.");
        }
    };

    const baseAmount = 5000;
    const discountedAmount = baseAmount - discount;
    const gst = 0.18 * discountedAmount;
    const finalAmount = discountedAmount + gst;




    const validateForm = () => {
        const errors = {};
        const { fullName, email, mobileNumber, verificationCode, password, rePassword, acceptPrivacyPolicy } = formData;

        if (!fullName) errors.fullName = 'Full Name is required';
        if (!email) errors.email = 'Email is required';
        if (!mobileNumber) errors.mobileNumber = 'Mobile Number is required';
        // if (!verificationCode) errors.verificationCode = 'Verification Code OTP is required';
        // if (!password) errors.password = 'Password is required';
        // if (!rePassword) errors.rePassword = 'Re-entering password is required';
        if (!acceptPrivacyPolicy) errors.acceptPrivacyPolicy = 'You must accept the privacy policy';

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!/^\d{10}$/.test(formData.mobileNumber)) {
            setFormErrors('Enter a valid 10-digit mobile number.');
            return;
        }

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setLoading(true);
        try {
            const { secrettoken, ts } = await getSecureToken();

            const response = await axios.post(`${API_BASE_URL}auth/Reg_pay.php`, formData, {
                headers: {
                    'X-TOKEN': secrettoken,
                    'X-TIMESTAMP': ts,
                },
                withCredentials: true,
            });

            const res = response.data;

            if (res.status === 'success') {
                if (res.action === 'existing_user' || res.action === 'new_user_created') {

                    handlePayment();
                } else if (res.action === 'mobile_exists') {
                    setLoading(false);
                    setVerificationMessage('Mobile number is already in use with another email.');
                    showCustomAlerterror('Mobile number is already in use with another email.');
                } else {
                    setLoading(false);
                    setVerificationMessage(res.message || 'Unhandled server response.');
                    showCustomAlerterror(res.message || 'Unhandled server response.');
                }
            } else {
                setLoading(false);
                setVerificationMessage(res.message || 'Signup failed.');
                showCustomAlerterror(res.message || 'Signup failed.');
            }
        } catch (error) {
            setLoading(false);
            console.error(error);
            setVerificationMessage('Server error. Please try again later.');
        }
    };



    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const handlePayment = async () => {
        const email = formData.email;
        if (!email) {
            showCustomAlerterror("User email not found. Please log in.");
            setLoading(false);
            return;
        }

        const amount = Math.max(finalAmount, 0);
        // if (amount < 3540) {
        //     amount = 5900;
        // }

        const isScriptLoaded = await loadRazorpayScript();

        if (!isScriptLoaded) {
            showCustomAlerterror("Failed to load Razorpay.");
            setLoading(false);
            return;
        }

        try {
            // STEP 1: Create Razorpay order
            const { data: paymentData } = await axios.post(
                `${API_BASE_URL}payment/complete_process_payment.php`,
                { amount},
                { withCredentials: true }
            );
            // console.log(paymentData)

            if (paymentData.status === "created") {
                const options = {
                    // test
                    // key: "rzp_test_MLxrHNXWtIdmfH",

                    //live
                    key: "rzp_live_VaCqiwAj83b37w",
                    amount: paymentData.amount,
                    currency: "INR",
                    order_id: paymentData.order_id,
                    description: `Premium Plan Payment by ${email}`,
                    handler: async function (response) {
                        // STEP 2: Verify Razorpay Signature
                        const { data: result } = await axios.post(
                            `${API_BASE_URL}payment/complete_process_payment.php`,
                            {
                                razorpay_payment_id: response.razorpay_payment_id,
                                razorpay_order_id: response.razorpay_order_id,
                                razorpay_signature: response.razorpay_signature,
                            },
                            { withCredentials: true }
                        );
                        // console.log(result)
                        if (result.status === "success") {
                            // showCustomAlert("Payment verified successfully!");
                            showCustomAlert(result.message);
                            localStorage.setItem('isuserlogin', 'true');
                            localStorage.setItem('autoLoginEmail', formData.email);


                            localStorage.setItem('userEmail', formData.email);
                            localStorage.setItem('fullName', formData.fullName);
                            localStorage.setItem('mobilenumber', formData.mobileNumber);
                            setTimeout(() => window.location.href = '/dashboard', 1000);
                        } else {
                            showCustomAlerterror("Payment verification failed");
                        }
                    },
                    modal: {
                        ondismiss: async function () {
                            showCustomAlerterror("Payment was not completed. User registration cancelled.");
                            setLoading(false);
                        },
                    },
                    prefill: { email },
                    theme: { color: "#21486f" },
                };

                const rzp = new window.Razorpay(options);
                rzp.open();
            } else {
                showCustomAlerterror("Failed to create payment order.");
                setLoading(false);
            }
        } catch (error) {
            showCustomAlerterror("Error processing payment.");
            setLoading(false);
        }
    };



    const resetForm = () => {
        setFormData({
            fullName: '',
            email: '',
            mobileNumber: '',
            verificationCode: '',
            password: '',
            rePassword: '',
            acceptPrivacyPolicy: false,
            botTrap: '',
        });
        setCouponCode('');
        setFormErrors({});
        setVerificationMessage('');
    };


    // const deleteUser = async (email) => {
    //     try {
    //         await axios.post(`${API_BASE_URL}auth/delete_user.php`, { email }, { withCredentials: true });
    //         resetForm();
    //     } catch (error) {
    //         console.error("Failed to delete user:", error);
    //     }
    // };


    const navigate = useNavigate();

    const closeModal = () => {
        navigate(-1); // Or use navigate('/') to go home
    };
    const formRef = useRef(null);

    // Get current date
    const currentDate = new Date();

    // Add 3 months
    const futureDate = new Date(currentDate.setMonth(currentDate.getMonth() + 3));

    // Format the date (e.g., 21 August 2025)
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    const formattedDate = futureDate.toLocaleDateString('en-US', options);


    return (
        <div>
            {loading && (
                <div className={style.loaderOverlay}>
                    <div className={style.loader}></div>
                </div>
            )}
            <AnimatePresence>

                <motion.div
                    className={style.modalOverlay}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.div
                        className={style.modalContent}
                        initial={{ y: "-100vh", opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: "100vh", opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <button className={style.closeBtn} onClick={closeModal}><i className="fa-solid fa-xmark"></i></button>
                        <div className={style.signupmodelbox}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h1 className={style.signupheading}>PAY NOW  </h1>
                                        {verificationMessage && <div className={style.infoMessage}>{verificationMessage}</div>}
                                        <form ref={formRef} onSubmit={handleSubmit}>

                                            <input type="text" name="botTrap" style={{ display: 'none' }} value={formData.botTrap || ''} onChange={handleChange} />

                                            <label className={style.signupcontent}>
                                                Full Name
                                                <div className={style.signupicons}>
                                                    <i className={`fa-solid fa-user ${style.signupIcons}`}></i>
                                                    <input className={style.signupmodalinputtxt} type="text" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="Your full name" />
                                                </div>
                                                {formErrors.fullName && <span className={style.error}>{formErrors.fullName}</span>}
                                            </label>

                                            <label className={style.signupcontent}>
                                                Email Address
                                                <div className={style.signupicons}>
                                                    <i className={`fa-solid fa-at ${style.signupIcons}`}></i>
                                                    <input className={style.signupmodalinputtxt} type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your email" />
                                                </div>
                                                {formErrors.email && <span className={style.error}>{formErrors.email}</span>}
                                            </label>

                                            <label className={style.signupcontent}>
                                                Mobile Number
                                                <div className={style.signupicons}>
                                                    <i className={`fa-solid fa-phone ${style.signupIcons}`}></i>

                                                    {/* <input className={style.signupmodalinputtxt} type="tel" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} placeholder="Contact number" /> */}

                                                    <input
                                                        className={style.signupmodalinputtxt}
                                                        type="tel"
                                                        name="mobileNumber"
                                                        value={formData.mobileNumber}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            // Sirf digits allow karo aur max 10 characters tak kaat do
                                                            if (/^\d{0,10}$/.test(value)) {
                                                                handleChange(e);
                                                            }
                                                        }}
                                                        placeholder="Contact number"
                                                        maxLength="10"
                                                    />



                                                </div>
                                                {formErrors.mobileNumber && <span className={style.error}>{formErrors.mobileNumber}</span>}
                                            </label>


                                            {formErrors.acceptPrivacyPolicy && <span className={style.error}>{formErrors.acceptPrivacyPolicy}</span>}


                                        </form>

                                        <p className={style.note_user}>
                                            Note: The  <strong>  Gmail ID & MOBILE NUMBER  </strong>  provided during registration is a permanent identifier and cannot be changed later. Access to SWINGALGO will be granted exclusively through this registered MOBILE NUMBER.
                                        </p>

                                        <div className={style.coupon}>
                                            <label className={style.signupcontent}>
                                                Coupon Code
                                                <div className={style.signupicons}>
                                                    <i className={`fa-solid fa-tag ${style.signupIcons}`}></i>
                                                    <input
                                                        className={style.signupmodalinputtxt}
                                                        type="text"
                                                        value={couponCode}
                                                        onChange={(e) => setCouponCode(e.target.value)}
                                                        placeholder="Enter coupon code"
                                                    />
                                                    <button type="button" className={style.applybtn} onClick={handleApplyCoupon}>
                                                        Apply
                                                    </button>
                                                </div>
                                            </label>
                                        </div>

                                    </div>

                                    <div className="col-md-6">
                                        <div className={style.card}>
                                            <h3 className={style.title}>PAYMENT INFORMATION</h3>
                                            <div className={style.pricing}>
                                                <div><span className={style.label}>Amount</span> <span>₹5000</span></div>
                                                {discount > 0 && (
                                                    <div><span className={style.label}>Coupon Discount</span> <span>-₹{discount}</span></div>
                                                )}
                                                <div><span className={style.label}>GST @ 18%</span> <span>{gst}</span></div>
                                                <div className={style.total}><span>Amount Payable</span> <span>₹{finalAmount}</span></div>
                                            </div>


                                            <div className={style.validity}>
                                                Your new plan will be valid till <strong style={{ whiteSpace: 'nowrap' }}>{formattedDate} (3 months)</strong>
                                            </div>
                                            <ul className={style.features}>
                                                <li><i className="fas fa-key"></i> Get Instant Access Now</li>
                                                <li><i className="fas fa-chart-line"></i> Premium (4) Swing Setups</li>
                                                <li><i className="fas fa-brain"></i> AI-Based Fundamental Analysis</li>
                                                <li><i className="fas fa-search"></i> Algoed Scanner</li>
                                                <li><i className="fas fa-user-shield"></i> Premium Community</li>

                                            </ul>
                                            <div className={style.terms}>
                                                <input
                                                    type="checkbox"
                                                    id="acceptPrivacyPolicy"
                                                    name="acceptPrivacyPolicy"
                                                    checked={formData.acceptPrivacyPolicy}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="acceptPrivacyPolicy">
                                                    I agree with <Link to={"/terms"}>Terms & Condition</Link>
                                                </label>
                                            </div>

                                            <button
                                                className={style.payBtn}
                                                onClick={() => formRef.current && formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))}
                                                disabled={loading}
                                            >
                                                {/* <i className="fa-brands fa-amazon-pay"></i> */}
                                                {loading ? "Processing..." : " Pay Now"}

                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>

            </AnimatePresence>
        </div>
    );
};

export default Register_paynow;
